<template>
  <div>
    <AllPendingCases></AllPendingCases>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllPendingCases = defineAsyncComponent(() =>
  import("@/components/pendingCases/AllApprovalPendingCases")
);
export default {
  components: {
    AllPendingCases,
  },
};
</script>
